import React from 'react'
import { TQuizProps } from "@health-zelas/quiz"

import Initial from './steps/Initial'
import { DentalPlan } from './steps/DentalPlan'
import PersonalData from './steps/PersonalData'
import Preferences from './steps/Preferences'
import { Result } from './steps/Result'
import WaitForContact from './steps/WaitForContact'
import { RequestQuotationError } from './steps/RequestQuotationError'
import apolloClient from '@packages/services/src/apolloClient'
import { LeadApps, SaveLeadDocument } from '@packages/services/src/apolloClient/gql/graphql'
import Cookies from 'js-cookie'

const getUtms = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const utmSource = urlParams.get('utm_source') || ''
  const utmMedium = urlParams.get('utm_medium') || ''
  const utmCampaign = urlParams.get('utm_campaign') || ''

  return {
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign
  }
}

export const SimulatorProps: TQuizProps = {
  localStorageKey: 'zelasSimulator',
  rootPath: '/simulador',
  onStepMount: () => {
    window?.LeadTracking?.pageView?.()
  },
  navigation: {
    PrevComponent: () => <div>prev</div>,
    NextComponent: () => <div>next</div>,
  },
  onNextStep: async () => {
    const { possui_cnpj, ...leadDataFromSimulatorState } = JSON.parse(localStorage?.getItem?.('zelasSimulator') || '{}')
    const leadId = Cookies.get('escaleLead') || localStorage?.getItem?.('escaleLead') || ''
    const leadData = {
      ...leadDataFromSimulatorState,
      possui_cnpj: possui_cnpj === 'Sim' ? true : false,
      leadId,
      website: 'saude.zelas.com.br/simulador',
      fonte_zd: 'organic_form_simulador',
      ...getUtms(),
    }

    try {
      const { data } = await apolloClient.mutate({
        mutation: SaveLeadDocument,
        variables: {
          leadData,
          from: LeadApps.Simulator
        }
      })

      const leadIdFromBff = data?.saveLead?.leadId

      const currentLeadId = leadIdFromBff || leadId || ''
      localStorage?.setItem('escaleLead', currentLeadId)
    } catch (error) {
      console.log(error)
    }
  },
  steps: [
    {
      path: '/',
      Component: Initial,
      nextSteps: () => '/dados-pessoais'
    },
    {
      path: '/dados-pessoais',
      Component: PersonalData,
      prevSteps: () => '/',
      nextSteps: (getFieldByName) => {
        const acceptedOptIn = getFieldByName('opt_in_parceiros')

        if(acceptedOptIn !== 'accepted'){
          return '/erro-ao-finalizar-simulacao'
        }

        return '/preferencias'
      },
    },
    {
      path: '/planos-odonto',
      Component: DentalPlan,
      prevSteps: () => '/',
    },
    {
      path: '/preferencias',
      Component: Preferences,
      nextSteps: () => '/resultado',
      prevSteps: () => '/dados-pessoais'
    },
    {
      path: '/resultado',
      Component: Result,
      prevSteps: () => '/dados-pessoais'
    },
    {
      path: '/aguarde-o-contato-cnpj',
      Component: WaitForContact,
      prevSteps: () => '/dados-pessoais'
    },
    {
      path: '/aguarde-o-contato',
      Component: WaitForContact,
      prevSteps: () => '/dados-pessoais'
    },
    {
      path: '/erro-ao-finalizar-simulacao',
      Component: RequestQuotationError,
    }
  ]
}
